import React from 'react';
import { Tooltip } from 'antd';

import { ReactComponent as ZoomInSVG } from '../icons/plus.svg';

export const ZoomIn: React.FC<{ onZoomIn: VoidFunction }> = ({ onZoomIn }) => {
  return (
    <Tooltip key={3} placement="top" title="Zoom In (Cmd +)">
      <ZoomInSVG onClick={onZoomIn} />
    </Tooltip>
  );
};
